import {
  USER_TRANSACTIONS_SUCCESS,
  USER_TRANSACTIONS_ERROR,
  USER_TRANSACTIONS_GET,
} from './transactionsActions';

export const initialState = {
  isFetching: false,
  hasError: false,
  errorMessage: '',
  items: [],
};

const transactionsReducer = {
  [USER_TRANSACTIONS_GET]: state => {
    return {
      ...state,
      transactions: {
        ...initialState,
        isFetching: true,
      },
    };
  },
  [USER_TRANSACTIONS_ERROR]: (state, { payload }) => {
    return {
      ...state,
      transactions: {
        ...initialState,
        hasError: true,
        errorMessage: payload,
      },
    };
  },
  [USER_TRANSACTIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      transactions: {
        ...initialState,
        isFetching: false,
        items: payload,
      },
    };
  },
};

export default transactionsReducer;
